import React from 'react';
import { motion } from 'framer-motion';
import { UseCaseSectionProps } from '@/types/components';
import { FileText, FolderOpen, GitBranch, Users } from 'lucide-react';

const USE_CASES = [
  {
    title: "Doc Ingestion",
    description: "Classification, Automated Summaries, and Routing for action and review",
    requestedBy: "Multi-line Mid-Sized Carrier",
    icon: "FileText"
  },
  {
    title: "Doc Management",
    description: "Replacing legacy systems with AI-enabled solutions",
    requestedBy: "Pre-need Carrier in Mid-west",
    icon: "FolderOpen"
  },
  {
    title: "Servicing Workflows",
    description: "Case management for servicing workflows",
    requestedBy: "Mid-size Life Carrier with focus on Living Benefits",
    icon: "GitBranch"
  },
  {
    title: "Party Sync",
    description: "Proactive monitoring of changes to party data",
    requestedBy: "TPA solving challenges for their carriers",
    icon: "Users"
  }
];

const IconMap = {
  FileText,
  FolderOpen,
  GitBranch,
  Users
};

const UseCaseSection: React.FC<UseCaseSectionProps> = ({ className }) => {
  return (
    <section id="use-cases" className="py-20 bg-gradient-to-b from-emerald-900 to-gray-900">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-4xl md:text-5xl font-bold mb-4 bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-emerald-400"
          >
            Example Insurance Use Cases
          </motion.h2>
          <p className="text-2xl text-gray-400">
            Real Solutions for Real Problems
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {USE_CASES.map((useCase, index) => {
            const Icon = IconMap[useCase.icon as keyof typeof IconMap];
            
            return (
              <motion.div
                key={useCase.title}
                className="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-8 border border-gray-700/50"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
              >
                <div className="flex items-start gap-6">
                  <Icon className="w-12 h-12 text-emerald-400 flex-shrink-0" />
                  <div>
                    <h3 className="text-2xl md:text-3xl font-semibold mb-3 text-white">
                      {useCase.title}
                    </h3>
                    <p className="text-xl text-gray-400 mb-4">
                      {useCase.description}
                    </p>
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default UseCaseSection;
